export default "__VITE_PUBLIC_ASSET__4956be57__"